import { Link } from "react-router-dom";
import { PROJECT_LOGO } from "../../lib/assets";

const legal_info_pages = [
  {
    page_name: "Cancellation & Refund Policy",
    path: "/legal/cancellation-&-refund-policy",
  },
  {
    page_name: "Terms & Conditions",
    path: "/legal/terms-&-conditions",
  },
  {
    page_name: "Shipping Policy",
    path: "/legal/shipping-policy",
  },
  {
    page_name: "Privacy Policy",
    path: "/legal/privacy-policy",
  },
  {
    page_name: "Legal Disclaimer",
    path: "/legal/legal-disclaimer",
  },
];

const pages = [
  {
    page_name: "Home",
    path: "/",
  },
  {
    page_name: "Contact us",
    path: "/contact",
  },
];

export const FooterThree = () => {
  return (
    <footer>
      <div className="footer-area-three">
        <div className="footer-top-three">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <div style={{ position: "relative", left: "-20px" }}>
                    <Link to="/">
                      <img src={PROJECT_LOGO} alt="" width={140} />
                    </Link>
                  </div>
                  <div className="footer-content">
                    <p>
                      Kadle Global Pvt Ltd is a leading innovator driving growth
                      through Technology, Infrastructure, Agriculture and
                      Renewable Energy sectors.
                    </p>
                    {/* <div className="footer-social footer-social-three">
                      <ul className="list-wrap">
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-pinterest-p"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Legal & Policy Information</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      {legal_info_pages.map((page, i) => (
                        <li index={i}>
                          <Link to={page.path}>{page.page_name}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Pages</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      {pages.map((page, i) => (
                        <li>
                          <Link to={page.path}>{page.page_name}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">Contact</h4>
                  <div className="footer-info">
                    <ul className="list-wrap">
                      <li>
                        <div className="icon">
                          <i className="flaticon-mail"></i>
                        </div>
                        <div className="content">
                          <a href="mailto:hi@kadleglobal.com">
                            hi@kadleglobal.com
                          </a>
                        </div>
                      </li>
                      {/* <li>
                        <div className="icon">
                          <i className="flaticon-phone-call"></i>
                        </div>
                        <div className="content">
                          <a href="tel:0123456789">+123 888 9999</a>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="flaticon-clock"></i>
                        </div>
                        <div className="content">
                          <p>
                            Mon – Sat: 8 am – 5 pm, <br /> Sunday:{" "}
                            <span>CLOSED</span>
                          </p>
                        </div>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom-three">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text-two text-center">
                  <p>
                    Copyright © Kadle Global Private Limited | All Right
                    Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
